export const menuCategoryKeys = {
  all: ['menu-categories'] as const,
  list: (companyId: number | null) => [...menuCategoryKeys.all, 'list', companyId] as const,
};
